import React from 'react';

const SpeakLoader = () => {
  return (
    <div className="flex justify-center items-center w-[100px] h-[100px] gap-[6px]">
      <div className="loading flex justify-center items-center gap-[6px]">
        <span className="w-[4px] h-[50px] bg-[#4c86f9] animate-scale" />
        <span className="w-[4px] h-[50px] bg-[#49a84c] animate-scale delay-[-0.8s]" />
        <span className="w-[4px] h-[50px] bg-[#f6bb02] animate-scale delay-[-0.7s]" />
        <span className="w-[4px] h-[50px] bg-[#f6bb02] animate-scale delay-[-0.6s]" />
        <span className="w-[4px] h-[50px] bg-[#2196f3] animate-scale delay-[-0.5s]" />
      </div>
    </div>
  );
}

export default SpeakLoader;
